import { render, staticRenderFns } from "./ViewRawDBData.vue?vue&type=template&id=6ac7508c&scoped=true"
import script from "./ViewRawDBData.vue?vue&type=script&lang=js"
export * from "./ViewRawDBData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7508c",
  null
  
)

export default component.exports